export default "__VITE_PUBLIC_ASSET__2cbf93ad__"